import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { Tabs, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Button } from "../components/ui/button";
import { HealthTab } from "../components/project/HealthTab";
import { ConversationsTab } from "../components/project/ConversationsTab";
import { TemplatesTab } from "../components/project/TemplatesTab";
import { SettingsTab } from "../components/project/SettingsTab";
import { BillingTab } from "../components/project/BillingTab";
import { OpsTab } from "../components/project/OpsTab";

const TABS = [
  { key: "health", label: "Health & Errors" },
  { key: "conversations", label: "Conversations" },
  { key: "templates", label: "Templates" },
  { key: "settings", label: "Settings" },
  { key: "billing", label: "Billing" },
  { key: "ops", label: "Ops Actions" },
];

export default function ProjectDashboard() {
  const { businessId, projectId } = useParams();
  const navigate = useNavigate();
  const [tab, setTab] = useState("health");
  const ids = { businessId, projectId };

  return (
    <div className="space-y-6" data-testid="project-dashboard">
      <div className="flex items-center gap-4">
        <Button
          variant="outline"
          size="icon"
          onClick={() => navigate(`/businesses/${encodeURIComponent(businessId)}`)}
          data-testid="back-to-business"
        >
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <div>
          <h1 className="font-display text-3xl font-extrabold tracking-tighter">Project Overview</h1>
          <p className="font-data text-xs text-muted-foreground mt-0.5">
            <span data-testid="project-business-id">{businessId}</span>
            <span className="mx-1.5">·</span>
            <span data-testid="project-id-label">{projectId}</span>
          </p>
        </div>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="flex-wrap h-auto gap-1" data-testid="project-tabs">
          {TABS.map((t) => (
            <TabsTrigger key={t.key} value={t.key} data-testid={`tab-${t.key}`}>
              {t.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>

      {tab === "health" && <HealthTab {...ids} />}
      {tab === "conversations" && <ConversationsTab {...ids} />}
      {tab === "templates" && <TemplatesTab {...ids} />}
      {tab === "settings" && <SettingsTab {...ids} />}
      {tab === "billing" && <BillingTab {...ids} />}
      {tab === "ops" && <OpsTab {...ids} />}
    </div>
  );
}
